import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateOptionValue } from '../../../api/apiOptionGroups';
import { toast } from 'react-hot-toast';
import parseError from '../../../utils/parseError';

/**
 * Hook to update an option value
 */
export const useUpdateOptionValue = () => {
    const queryClient = useQueryClient();

    const { mutate: editOptionValue, isPending: isUpdating } = useMutation({
        mutationFn: ({ optionGroupId, valueId, data }) => updateOptionValue(optionGroupId, valueId, data),
        onSuccess: (res) => {
            queryClient.invalidateQueries({ queryKey: ['optionValues'] });
            toast.success(res?.data?.message);
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message);
        }
    });

    return { editOptionValue, isUpdating };
};
